import { toV1AccessToken, toV1BasicToken } from '../api-v3/apiProxy';

export async function getCompanyMenu(params: { companyId: string }) {
  return toV1AccessToken({
    url: `/menu?companyId=${params.companyId}`,
    method: 'GET',
  });
}

export async function updateCompanyMenu(body: {
  companyId: string;
  accessibleMenu: API.Menu[];
}) {
  return toV1AccessToken({
    url: '/menu',
    method: 'POST',
    data: body,
  });
}

export async function registerCompany(body: API.RegisterCompanyParamDto) {
  return toV1AccessToken({
    url: '/company/create',
    method: 'POST',
    data: body,
  });
}

export async function removeCompanyCompletely(body: { id: string }) {
  return toV1AccessToken({
    url: '/company/delete',
    method: 'POST',
    data: body,
  });
}

// brandname
export async function getBrandNameList(params: {
  // query
  current?: number;
  pageSize?: number;
  sort?: string;
  select?: string;
  filter?: Record<string, any>;
}): Promise<API.BrandNameListDto> {
  const body = { page: 0, count: 1000, companyId: '' };
  if (params.filter && 'companyId' in params.filter) {
    body.companyId = params.filter.companyId;
  }
  const res = await toV1AccessToken({
    url: '/brand_name/get-list',
    method: 'POST',
    data: {
      ...body,
    },
  });

  const resRemap: API.BrandNameListDto = {
    data: res.results.result,
    total: res.results.result?.length || 0,
    current: 0,
    pageCount: res.results.result?.length || 0,
    pageSize: -1,
  };

  return resRemap;
}

export async function getBrandNamePartnerList(params: {
  // query
  current?: number;
  pageSize?: number;
  sort?: string;
  select?: string;
  filter?: Record<string, any>;
}): Promise<API.BrandNameListDto> {
  const body = { page: 0, count: 1000, companyId: '' };
  if (params.filter && 'companyId' in params.filter) {
    body.companyId = params.filter.companyId;
  }
  const res = await toV1AccessToken({
    url: '/brand_name/get-partner-list',
    method: 'POST',
    data: {
      ...body,
    },
  });

  const resRemap: API.BrandNameListDto = {
    data: res.results.result,
    total: res.results.result?.length || 0,
    current: 0,
    pageCount: res.results.result?.length || 0,
    pageSize: -1,
  };

  return resRemap;
}

export async function createBrandName(
  body: API.BrandNameCreatedDto,
): Promise<API.BrandNameCreatedResponse> {
  return toV1AccessToken({
    url: '/brand_name/create',
    method: 'POST',
    data: {
      ...body,
    },
  });
}

export async function updateBrandName(
  body: API.BrandNameCreatedDto,
): Promise<API.BrandNameCreatedResponse> {
  return toV1AccessToken({
    url: '/brand_name/update',
    method: 'POST',
    data: {
      ...body,
    },
  });
}

export async function deleteBrandName(
  body: API.BrandNameCreatedDto,
): Promise<API.BrandNameCreatedResponse> {
  const { id } = body;
  return toV1AccessToken({
    url: '/brand_name/delete',
    method: 'POST',
    data: {
      id,
    },
  });
}

export async function getServiceSupporter(): Promise<
  API.ApiV1BaseResponse<{ serviceSupporter: Record<string, number> }>
> {
  return toV1AccessToken({
    url: '/system_parameter/serviceSupporter',
    method: 'GET',
  });
}

export async function getCompanyView(
  companyId: string,
): Promise<API.ApiV1BaseResponse<{ company: API.CompanyV1Dto }>> {
  return toV1AccessToken({
    url: `/company/view`,
    method: 'POST',
    data: {
      id: companyId,
      companyId,
    },
  });
}

export async function updateCompanyFeeConfig(
  data: API.CompanyFeeConfigDto,
): Promise<API.ApiV1BaseResponse<unknown>> {
  return toV1AccessToken({
    url: `/company-crm/update`,
    method: 'POST',
    data: {
      ...data,
    },
  });
}

export async function triggerDataSync(
  data: API.TriggerDataSyncDto,
): Promise<API.ApiV1BaseResponse<unknown>> {
  return toV1AccessToken({
    url: `/cron/sync-tickets`,
    method: 'POST',
    data: {
      ...data,
    },
  });
}

export async function walletRefund(
  data: API.WalletRefundParamsDto,
): Promise<API.ApiV1BaseResponse<unknown>> {
  return toV1BasicToken({
    url: `/wallet/rollback`,
    method: 'POST',
    data: {
      ...data,
    },
  });
}

export async function runSystemPayFee(data: API.RunSystemPayFeeParamDto) {
  return toV1BasicToken({
    url: `/admin/run-system-pay-fee?dateMsAction=${data.dateMsAction}${
      data.companyId ? `&companyId=${data.companyId}` : ''
    }`,
    method: 'GET',
  });
}

export async function getAppConfig(params: { companyId: string }): Promise<
  API.ApiV1BaseResponse<{
    appConfigs: API.AppConfigDto[];
  }>
> {
  return toV1AccessToken({
    url: `/appConfig?companyId=${params.companyId}`,
    method: 'GET',
  });
}

export async function createAppConfig(params: API.AppConfigDto): Promise<
  API.ApiV1BaseResponse<{
    appConfigs: API.AppConfigDto[];
  }>
> {
  return toV1AccessToken({
    url: `/appConfig`,
    data: params,
    method: 'POST',
  });
}

export async function updateAppConfig(params: API.AppConfigDto): Promise<
  API.ApiV1BaseResponse<{
    appConfigs: API.AppConfigDto[];
  }>
> {
  return toV1AccessToken({
    url: `/appConfig`,
    data: params,
    method: 'PUT',
  });
}
/**
 *
 * @returns
 */
export async function getInvoiceConfig(params: {
  // query
  current?: number;
  pageSize?: number;
  sort?: string;
  select?: string;
  filter?: Record<string, any>;
}): Promise<API.ReMapListResponse<API.InvoiceConfigDto[]>> {
  // const body = { page: 0, count: 1000, companyId: '' };
  // if (params.filter && 'companyId' in params.filter) {
  //   body.companyId = params.filter.companyId;
  // }
  const res = await toV1AccessToken({
    url: '/invoice_provider/list',
    method: 'POST',
    // data: {
    //   ...body,
    // },
  });

  // filter
  const filteredData = res.results.listInvoice.filter(
    (item: API.InvoiceConfigDto) => {
      // check if paramsKeys is subset of paramsKeys
      return Object.keys(params || {}).every((key) => {
        if (key in item) {
          return (
            item[key as keyof API.InvoiceConfigDto] ===
            params?.[key as keyof typeof params]
          );
        }
        return true;
      });
    },
  );

  const resRemap: API.ReMapListResponse<API.InvoiceConfigDto[]> = {
    data: filteredData,
    total: filteredData?.length || 0,
    current: params.current || 0,
    pageCount: filteredData?.length || 0,
    pageSize: params.pageSize || -1,
  };

  return resRemap;
}

export async function createInvoiceConfig(
  params: API.InvoiceConfigDto,
): Promise<
  API.ApiV1BaseResponse<{
    invoiceConfigs: API.InvoiceConfigDto[];
  }>
> {
  return toV1AccessToken({
    url: `/invoice_provider/create`,
    data: params,
    method: 'POST',
  });
}

export async function updateInvoiceConfig(
  params: API.InvoiceConfigDto,
): Promise<
  API.ApiV1BaseResponse<{
    invoiceConfigs: API.InvoiceConfigDto;
  }>
> {
  return toV1AccessToken({
    url: `/invoice_provider/update`,
    data: params,
    method: 'POST',
  });
}

export async function deleteInvoiceConfig(id: string): Promise<
  API.ApiV1BaseResponse<{
    invoiceConfigs: API.InvoiceConfigDto[];
  }>
> {
  return toV1AccessToken({
    url: `/invoice_provider/delete`,
    data: { id },
    method: 'POST',
  });
}

export async function getMerchantPayment(params: {
  companyId?: string;
  gateway?: string;
  [key: string]: any;
}): Promise<API.ApiV1BaseResponse<API.MerchantResponse>> {
  const queryParams = new URLSearchParams();
  // Add all parameters to query string
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ''
    ) {
      queryParams.append(key, params[key].toString());
    }
  });

  return toV1AccessToken({
    url: `/crm/merchant?${queryParams.toString()}`,
    method: 'GET',
  });
}

export async function getFreeVehicle(params: {
  companyId: string;
}): Promise<API.GetFreeVehicleResponse> {
  return toV1AccessToken({
    url: `/crm/vehicle/getFreeVehicle?companyId=${params.companyId}`,
    method: 'GET',
  });
}

export async function updateMerchantPayment(params: {
  gateway: string;
  merchantId?: string;
  companyId: string;
  hash?: string;
  accessCode?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  // Add other gateway-specific fields as needed
  [key: string]: any;
}): Promise<API.ApiV1BaseResponse<any>> {
  const { gateway, ...updateData } = params;

  // Use gateway-specific endpoint
  const endpoint = `/${gateway.toLowerCase()}/merchant`;

  return toV1AccessToken({
    url: endpoint,
    method: 'POST', // Based on your curl, it seems to be POST not PUT
    data: updateData,
  });
}

// Gateway-specific update functions for better type safety
export async function updateMomoMerchant(params: {
  merchantId: string;
  companyId: string;
  hash: string;
  accessCode: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/momo/merchant',
    method: 'POST',
    data: params,
  });
}

export async function updateVnpayMerchant(params: {
  merchantId: string;
  companyId: string;
  hash: string;
  accessCode?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/vnpay/merchant',
    method: 'POST',
    data: params,
  });
}

export async function updateZalopayMerchant(params: {
  appId: string | number;
  companyId: string;
  macKey: string;
  cbKey: string;
  merchantName?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/zalopay/merchant',
    method: 'POST',
    data: params,
  });
}

export async function updateShopeePayMerchant(params: {
  merchantId: string;
  companyId: string;
  storeId: string;
  appKey: string;
  returnUrl?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/shopeepay/merchant',
    method: 'POST',
    data: params,
  });
}

export async function updateMegapayMerchant(params: {
  merchantId: string;
  companyId: string;
  hash?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  isProduction?: boolean;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/megapay/merchant',
    method: 'POST',
    data: params,
  });
}

export async function createOnepayMerchant(params: {
  merchantId: string;
  companyId: string;
  hash: string;
  accessCode: string;
  transactionPercent?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/onepay/merchant',
    method: 'POST',
    data: params,
  });
}

export async function updateOnepayMerchant(params: {
  merchantId: string;
  companyId: string;
  hash: string;
  accessCode: string;
  returnLink?: string;
  againLink?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/onepay/update',
    method: 'POST',
    data: params,
  });
}

export async function updateVnpayQrMerchantVehicle(params: {
  id: string;
  merchantId: string;
  companyId: string;
  hash: string;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  listVehicleId: string[];
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/vnpay/qr/merchant-vehicle/update',
    method: 'POST',
    data: params,
  });
}

export async function createVnpayQrMerchantVehicle(params: {
  merchantId: string;
  companyId: string;
  hash: string;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  listVehicleId: string[];
  isProduction?: boolean;
  merchantPlatforms?: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/vnpay/qr/merchant-vehicle',
    method: 'POST',
    data: params,
  });
}

export async function createMerchantPayment(params: {
  gateway: string;
  companyId: string;
  merchantId?: string;
  hash?: string;
  accessCode?: string;
  transactionPercent?: number | null;
  transactionFee?: number | null;
  isProduction?: boolean;
  anvuiUser?: {
    id: string;
    userName: string;
  };
  merchantPlatforms?: string[];
  // Add other gateway-specific fields as needed
  [key: string]: any;
}): Promise<API.ApiV1BaseResponse<any>> {
  const { gateway, ...createData } = params;

  // Use gateway-specific endpoint for creation
  const endpoint = `/${gateway.toLowerCase()}/merchant`;

  return toV1AccessToken({
    url: endpoint,
    method: 'POST',
    data: createData,
  });
}

export async function getVehicleUtilitiesList(params: {
  // query
  current?: number;
  pageSize?: number;
  sort?: string;
  select?: string;
  name?: string;
}): Promise<API.ApiV1BaseResponse<any>> {
  const body = { page: 0, count: 1000, name: '' };
  if (params?.name) {
    body.name = params.name;
  }
  return toV1AccessToken({
    url: '/utility/vehicle/get-list',
    method: 'POST',
    data: {
      ...body,
    },
  });
}

// System Notification
export async function getSystemNotificationList(): Promise<API.SystemNotificationListResponse> {
  return toV1AccessToken({
    url: '/systemNotification',
    method: 'GET',
  });
}

export async function createSystemNotification(
  body: API.SystemNotificationDto,
): Promise<
  API.ApiV1BaseResponse<{ systemNotification: API.SystemNotificationDto }>
> {
  return toV1AccessToken({
    url: '/systemNotification',
    method: 'POST',
    data: body,
  });
}

export async function updateSystemNotification(
  body: API.SystemNotificationDto & { id: string },
): Promise<
  API.ApiV1BaseResponse<{ systemNotification: API.SystemNotificationDto }>
> {
  return toV1AccessToken({
    url: '/systemNotification',
    method: 'PUT',
    data: body,
  });
}

export async function deleteSystemNotification(id: string) {
  return toV1AccessToken({
    url: '/systemNotification',
    method: 'DELETE',
    data: { id },
  });
}

export async function createUpdateVehicleUtilities(params: {
  id?: string;
  name: string;
  unit: string;
  listImage: string[];
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: `/utility/vehicle${params.id ? '/update' : '/create'}`,
    method: 'POST',
    data: params,
  });
}

export async function etransactionReport(
  body: API.EtransactionReportParams,
): Promise<API.EtransactionReportResponse> {
  return toV1AccessToken({
    url: '/etransaction/etransaction-report',
    method: 'POST',
    data: body,
  });
}

export async function getPartnerListV1(): Promise<
  API.ApiV1BaseResponse<{ listPartner: API.PartnerV1Dto[] }>
> {
  return toV1AccessToken({
    url: '/partner/list',
    method: 'GET',
  });
}

export async function updatePartnerV1(
  params: API.PartnerV1Dto,
): Promise<API.ApiV1BaseResponse<{ partner: API.PartnerV1Dto }>> {
  return toV1BasicToken({
    url: '/partner/crm/update',
    method: 'POST',
    data: params,
  });
}

export async function createPartnerV1(
  params: API.PartnerV1Dto,
): Promise<API.ApiV1BaseResponse<{ partner: API.PartnerV1Dto }>> {
  return toV1AccessToken({
    url: '/partner/v2/create',
    method: 'POST',
    data: params,
  });
}

export async function deletePartnerV1(
  id: string,
): Promise<API.ApiV1BaseResponse<{ partner: API.PartnerV1Dto }>> {
  return toV1AccessToken({
    url: '/partner/v2/delete',
    method: 'POST',
    data: { id },
  });
}

export async function createPartnerStaffV1(
  params: API.PartnerStaffV1Dto,
): Promise<API.ApiV1BaseResponse<{ partnerUser: API.PartnerStaffV1Dto }>> {
  return toV1AccessToken({
    url: '/v2/partner/create-user',
    method: 'POST',
    data: params,
  });
}

export async function changePartnerBalanceV1(params: {
  id: string;
  amount: number;
  note: string;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/partner/crm/change-balance',
    method: 'POST',
    data: params,
  });
}

export async function chargeAnvuiWallet(params: {
  companyId: string;
  amount: number;
  amountPromotion?: number | null;
  balanceType?: number;
  detailsType?: number;
  isAddWallet: boolean;
  description: string;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/wallet/charge-anvui-wallet',
    method: 'POST',
    data: params,
  });
}

export async function companyPaymentGetList(body: {
  page: number;
  count: number;
  paymentStatus: number;
}): Promise<any> {
  return toV1AccessToken({
    url: '/company_payment/getList',
    method: 'POST',
    data: body,
  });
}

export async function createCompanyPayment(body: {
  companyId: string;
  transactionAmount: number;
  paymentType: number;
  detailsType?: number | undefined;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/mb/create-payment',
    method: 'POST',
    data: body,
  });
}

export async function userUpdateInfo(params: {
  userId: string;
  password: string;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1BasicToken({
    url: '/user/crm-updateinfo',
    method: 'POST',
    data: params,
  });
}

export async function userSetAdmin(params: {
  userId: string;
  isAdmin: boolean;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/user/set-admin',
    method: 'POST',
    data: params,
  });
}

export async function znsAccount(params: {
  companyId?: string;
  filter?: Record<string, any>;
  current?: number;
  pageSize?: number;
  sort?: string;
  select?: string;
}): Promise<any> {
  const ownerId = params?.filter?.ownerId || '';
  const statusFilter = params?.filter?.statusFilter;
  const searchParams = new URLSearchParams();
  if (ownerId) {
    searchParams.set('companyId', ownerId);
  }
  if (statusFilter !== undefined && statusFilter !== null) {
    searchParams.set(
      'isActive',
      String(statusFilter) === '1' ? 'true' : 'false',
    );
  }
  const queryString = searchParams.toString()
    ? `?${searchParams.toString()}`
    : '';

  const res = await toV1AccessToken({
    url: `/zns${queryString}`,
    method: 'GET',
  });

  const data =
    res?.results?.znses?.sort(
      (a: any, b: any) => b.createdDate - a.createdDate,
    ) ?? [];
  const total = data.length;

  return {
    data,
    total,
    current: 0,
    pageCount: total,
    pageSize: -1,
  };
}

export async function updateZnsAccount(params: {
  id: string;
  appId: string;
  appSecret: string;
  pageId: string;
  user: string;
  password: string;
  price: number;
  serviceSupport: number;
  companyId: string;
  isActive: boolean;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/zns',
    method: 'PUT',
    data: params,
  });
}

export async function addZnsAccount(params: {
  appId: string;
  appSecret: string;
  pageId: string;
  user: string;
  password: string;
  price: number;
  serviceSupport: number;
  companyId: string;
  isActive: boolean;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/zns',
    method: 'POST',
    data: params,
  });
}

export async function deleteZnsAccount(params: {
  id: string;
}): Promise<API.ApiV1BaseResponse<any>> {
  return toV1AccessToken({
    url: '/zns',
    method: 'DELETE',
    data: params,
  });
}
